export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10695.9be7f587.jpg";